import "./campaign-detail-landing-card.scss"
import EmpTextInput from "../../../components/shared/emp-text-input/emp-text-input";
import { FormControl } from "../../../utilities/formUtils/formControl";


interface Props {
    className?: string
}

const CampaignDetailLandingCard = (props: Props) => {


    const form = {
        campaignName: new FormControl("text", [], ""),
        budget: new FormControl("text", [], "")
    }

    return (
        <div>
            <div className='emrg-demo-cards campaign-detail-main-card-wrapper'>
                <div className='card-header'>
                    <h3>Create Campaign Details</h3>
                    <p className='color-gray-300'>Specify campaign details, and references needed for the talent</p>
                </div>
                <div style={{ flex: 1 }}></div>

                <div className="campaign-detail-card-wrapper">

                    {/* Campaign Name Text Field */}

                    <div className='h-stack'>
                        <div className='pr-2' style={{ flex: 1 }}>
                            <EmpTextInput
                                labelText='Campaign Name'
                                id="campaign-name"
                                initialValue='My wonderful campaign'
                                placeholder='Campaign Name'
                                formControl={form.campaignName}
                            />
                        </div>
                        <div className='pl-2' style={{ flex: 1 }}>
                            <EmpTextInput
                                labelText='Budget'
                                id="budget"
                                initialValue='14,000'
                                placeholder='Budget'
                                formControl={form.budget} />
                        </div>
                    </div>
                    <label className="reference-img-label mt-6">Reference Images</label>
                    <div className='h-stack reference-img-wrapper'>
                        <div className='img-wrapper'>
                            <img alt='reference pic 1' src='https://randomwordgenerator.com/img/picture-generator/5ee6d6454d57b10ff3d8992cc12c30771037dbf852547848702a7ed4974c_640.jpg' />
                        </div>
                        <div className='img-wrapper'>
                            <img alt='reference pic 2' src='https://randomwordgenerator.com/img/picture-generator/55e7d7464b55a914f1dc8460962e33791c3ad6e04e507440762e7adc9e45c3_640.jpg' />
                        </div>
                        <div className='img-wrapper'>
                            <img alt='reference pic 3' src='https://randomwordgenerator.com/img/picture-generator/5ee6dc434950b10ff3d8992cc12c30771037dbf85254784b732f7ad0914e_640.jpg' />
                        </div>
                        <div className='img-wrapper'>
                            <img alt='reference pic 4' src='https://randomwordgenerator.com/img/picture-generator/55e1d54a4d57ab14f1dc8460962e33791c3ad6e04e50744076297cd49349cc_640.jpg' />
                        </div>
                    </div>
                </div>

            </div>
        </div >
    )
}
export default CampaignDetailLandingCard
